import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { AreaChart, Tooltip, Area, ResponsiveContainer } from 'recharts';
import TrendingUpIcon from 'mdi-react/TrendingUpIcon';
import TrendingDownIcon from 'mdi-react/TrendingDownIcon';
import PropTypes from 'prop-types';
import axios from 'axios';
import { isArray } from 'util';
import config from "../../../config";

const CustomTooltip = ({ active, payload }) => {
  if (active) {
    return (
      <div className="dashboard__total-tooltip">
        <p className="label">{`$${isArray(payload) && payload.length && payload[0].value}`}</p>
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
  })),
};

CustomTooltip.defaultProps = {
  active: false,
  payload: null,
};

export default class CoinPriceChart extends PureComponent {
  constructor() {
    super();
    this.state = {
      price: 0,
      change: 0,
      history: []
    };
  }

  componentDidMount = async () => {
    try {
      const { identificator } = this.props;
  
      const { data: { history } } = await axios.get(`${config.API_ADDR}/coins/${identificator}`)

      const parsedHistory = [];

      history.slice().reverse().forEach((element) => {
        parsedHistory.push({ coin: parseFloat(parseFloat(element).toFixed(2)) });
      });

      const price = parseFloat(history[0]);
      const oldPrice = parseFloat(history[history.length - 1]);
      const change = 100 - ( (oldPrice * 100) / price);
      this.setState({ price, change, history: parsedHistory });
    } catch (error) {
      console.log(error);
    }

  }


  render() {
    return (
      <Col md={12} xl={12} lg={12} xs={12}>
        <Card>
          <CardBody className="dashboard__card-widget">
            <div className="card__title">
              <h5 className="bold-text">{this.props.name}</h5>
              <h5 className="subhead">{this.state.change.toFixed(2)}%</h5>
            </div>
            <div className="dashboard__total dashboard__total--area">
              {this.state.change > 0 ? <TrendingUpIcon className="dashboard__trend-icon" /> : <TrendingDownIcon className="dashboard__trend-icon" style={{ fill: '#ff4861' }} />}
              <p className="dashboard__total-stat">
                ${this.state.price.toFixed(this.state.price >= 1000 ? 0 : 2)}
              </p>
              <ResponsiveContainer height={70} className="dashboard__chart-container">
                <AreaChart data={this.state.history} margin={{ top: 0, left: 0, bottom: 0 }}>
                  <Tooltip content={<CustomTooltip />} />
                  <Area
                    name="BCH"
                    type="monotone"
                    dataKey="coin"
                    fill={this.props.fill}
                    stroke={this.props.stroke}
                    fillOpacity={0.2}
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}
